import React from 'react'
import styles from './MetricsPicker.scss'
import { BlockOverlay } from '../../BlockOverlay'
import { metricsSpec as tripMetricsSpec, routeMetricsSpec } from 'common/Metrics'
import { Button } from 'common/Button'
import { Msg, commonVerbs } from 'lib/localization'
import { List } from 'immutable'
import { FormattedMessage as T } from 'react-intl'

const MAX_METRICS = 5
const MIN_METRICS = 2

export class MetricsPicker extends React.Component {
  constructor (props) {
    super(props)
    this.state = { selected: new List(props.selected) }
  }

  confirmSelection = () => {
    const { onConfirm } = this.props
    const { selected } = this.state
    onConfirm(selected.toJS())
  }

  toggle = (metric) => {
    const { selected } = this.state
    if (selected.includes(metric)) {
      this.setState({ selected: selected.filterNot(v => v === metric) })
    } else {
      if (selected.size >= MAX_METRICS + 1) { return }
      this.setState({ selected: selected.push(metric) })
    }
  }

  render () {
    const { onClose, objectType } = this.props
    const { selected } = this.state

    const tooMany = selected.size > MAX_METRICS
    const tooFew = selected.size < MIN_METRICS
    const disableButton = tooMany || tooFew

    const metricsSpec = objectType && objectType === 'route'
      ? routeMetricsSpec
      : tripMetricsSpec

    return (
      <BlockOverlay onClose={onClose}>
        <div className={styles.MetricsPicker}>
          <h1><T id='MetricsPicker.select' defaultMessage='Select Metrics' /></h1>
          <p><T id='MetricsPicker.pickMetrics' defaultMessage='Pick the metrics you want displayed at the bottom of the map' />:</p>
          <div className={styles.list}>
            {metricsSpec.map((v, k) => (
              <div className={styles.listItem} key={k}>
                <label>
                  <input type='checkbox' checked={selected.includes(k)} onChange={() => this.toggle(k)} /> <Msg startCase m={v.label} />
                </label>
              </div>
            )).toIndexedSeq().toJS()}
          </div>
          {tooMany && <p className={styles.infoMessage}>
            <T id='MetricsPicker.tooMany' defaultMessage='You have too many metrics selected! Please select between 3 and 5 metrics to display.' />
          </p>}
          {tooFew && <p className={styles.infoMessage}>
            <T id='MetricsPicker.tooFew' defaultMessage='You have too few metrics selected! Please select between 3 and 5 metrics to display.' />
          </p>}
          <Button type='default' onClick={!disableButton && this.confirmSelection} disabled={disableButton}><Msg lowerCase m={commonVerbs.save} /></Button>
        </div>
      </BlockOverlay>
    )
  }
}
